



























import { computed } from "@vue/composition-api";
import Vue from "vue";
export default Vue.extend({
  props: ["items"],
  setup(props) {
    const domain = computed(() => {
      const domain_reg_ex = /(https?:\/\/[^/]+)/;
      // @ts-ignore
      const match = domain_reg_ex.exec(props.items[0]);
      if (match) {
        return match[1];
      }
      return "?";
    });

    const rest_of_path = computed(() => {
      // @ts-ignore
      return props.items[0]
        .replace(domain.value, "")
        .split("/")
        .filter((d: string) => d);
    });
    return { domain, rest_of_path };
  },
});
